<template>
  <div>
    <h2>{{ title }}</h2>
    <apexchart
      type="pie"
      :options="chartOptions"
      :series="series"
      height="350"
    ></apexchart>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'PieChart',
  props: {
    title: {
      type: String,
      required: true,
    },
    series: {
      type: Array,
      required: true,
      default: () => [],
    },
    chartLabels: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  setup(props) {
    const chartOptions = computed(() => ({
      chart: {
        type: 'pie',
        theme: 'dark',
      },
      labels: props.chartLabels,
      legend: {
        labels: {
          colors: '#fff'
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    }));

    return {
      chartOptions,
    };
  }
};
</script>